// extracted by mini-css-extract-plugin
export default {"wrap":"PricingPlanBanner_wrap__zcaaO"};